module.exports = __webpack_public_path__ + "static/media/btn_bird_active.178a3129.png";